import script from "./BestsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BestsModal.vue?vue&type=script&setup=true&lang=js"

import "./BestsModal.vue?vue&type=style&index=0&id=00313b5b&lang=scss"

const __exports__ = script;

export default __exports__